import { useState, useMemo } from 'react';
import Realtimegraph from "./realtimegraph2.js"

export default function Realtimeearthquakegraphpanel(props) {
  const [ranges] = useState([]);
  const [wins, setwins] = useState([]);

  function yRange(sid, value) {
    if (!isNaN(value)) ranges[sid] = (value);
    let obj = Object.values(ranges);
    return Math.max(...obj, 10);
  }

  function recievewin(sid, winobj) {
    wins[sid] = winobj;
    let awins = [];
    Object.keys(wins).forEach(key => awins[key] = wins[key]);
    setwins(awins);
  }

  const allGraphs = [];
  props.sensors.forEach(sensor => {
    const sid = sensor.id;
    const names = sensor.name;
    names.forEach((name, index) => {
      allGraphs.push({
        sid: sid,
        no: String(index),
        name: name + "加速度",
      });
    });
    allGraphs.reverse()
  });

  return (
    <>
      {allGraphs.map((data, index) => (
        <div key={data.no}>
          <div>
            <Realtimegraph
              uid='57'
              sid={data.sid}
              no={data.no}
              name={data.name}
              height={props.height}
              yRangeFunction={yRange}
              recievewinFunction={recievewin}
            />
          </div>
        </div>
      ))}
    </>
  );

}
